import { t } from "i18n/i18n";
import { EmptyCard } from "mds/components/EmptyCard";
import { AssessPointsMarkerIcon } from "mds/icons";

export const EmptyAssessmentDashboard = () => (
  <main className="assessment-dashboard">
    <EmptyCard
      className="text-base"
      description={t("assessment_dashboard.empty.description")}
      icon={<AssessPointsMarkerIcon className="text-blue" />}
      title={t("assessment_dashboard.empty.title")}
    />
  </main>
);
